module.exports = __webpack_public_path__ + "img/next-loot-4.f981b5d6.png";